// State machine updater: needs refactoring:
import isEqual from 'lodash/isEqual'

/* ---------------------------------------------------------------------------------------------------------------
 * BUGFIX AIR-35444

 *  1. isSlice1
 *    - In Initial state (on load) - if user-selected filter values and OG values are different - highlight chip
 *    - Not In Initial state - chips will stay highlighted because filters remains retained (unless we reset)
 *      - When reset/manually de-select the checkboxes, "values" will equal initial state
 *  2. not isSlice1
 *    - Apply original logic by comparing current values against OG with properties involving "2" ()
 *  
 * --------------------------------------------------------------------------------------------------------------- */

/**
 * Assign OG values, initial values, and proper conditions for chip highlight toggle
 * @param {*} ogValues                      - Previous filter values
 * @param {*} values                        - Current filter values
 * @param {*} type                          - "STOPS" vs "AIRLINES"
 * @param {*} selectedStopsProperty         - Current selected stop filter properties
 * @param {*} excludeCarriersProperty       - Airlines ogValues/value property
 * @param {*} includeCarriersProperty       - Airlines
 * @returns                                 - Object: {initial: {0: bool, 1: bool, 7: bool} or [], initialCase: bool, normalCase: bool baseCase: bool }
 */
const getChipStatus = (
  ogValues,
  values,
  type = '',
  selectedStopsProperty,
  excludeCarriersProperty,
  includeCarriersProperty
) => {
  let initial, curr, prev // states
  switch (type) {
    case 'STOPS':
      initial = { 0: false, 1: false, 7: false }
      curr = values[selectedStopsProperty] // Current values after user check filter boxes
      prev = ogValues[selectedStopsProperty] // Previous values

      return {
        initial: initial,
        initialCase: !isEqual(curr, prev),
        normalCase: !isEqual(curr, initial),
        baseCase: !isEqual(values.selectedStops2, ogValues.selectedStops2),
      }

    case 'AIRLINES':
      initial = []
      curr = values[excludeCarriersProperty]
      prev = ogValues[excludeCarriersProperty]
      let isCarrierExists = values[includeCarriersProperty]?.length !== 0

      return {
        initial: initial,
        initialCase: !isEqual(curr, prev) && isCarrierExists,
        normalCase: !isEqual(curr, initial) && isCarrierExists,
        baseCase:
          !isEqual(values.excludedCarriers2, ogValues.excludedCarriers2) &&
          values.includedCarriers2.length !== 0,
      }

    default:
      return {}
  }
}

/**
 * Determine if filter chip should highlight based on conditions provided from "getChipStatus"
 * @param {*} props                         - Identical as above
 * @returns                                 - Bool
 */
export const toggleChipsHighlight = (
  ogValues,
  values,
  isSlice1,
  type = '',
  selectedStopsProperty,
  excludeCarriersProperty,
  includeCarriersProperty
) => {
  let { initial, initialCase, normalCase, baseCase } = getChipStatus(
    ogValues,
    values,
    type,
    selectedStopsProperty,
    excludeCarriersProperty,
    includeCarriersProperty
  )

  // Check if we're in initial State (no active filters)
  let isInitialState = isEqual(ogValues, initial)

  // If initialState -> if current filter fields !== og fields -> highlight
  // Else if already highlighted, stay highlighted unless reset
  if (isSlice1) return isInitialState ? initialCase : normalCase

  // Compare against OG props with "2" as a field
  return baseCase
}
